<template>

  <b-modal
      id="modal-report-dialog-routine-by-part"
      ref="modal"
      title="Relatório Avançado"
      cancel-title="Cancelar"
      @show="onShow"
      @hidden="onHidden"
      @ok="handleOk">

    <validation-observer ref="validation">


      <b-form @submit.prevent="onSubmit" ref="form">

        <t-form-wrapped :command="command" :status="onStatus">
          <b-card-title>E-mail para aviso de relatório processado</b-card-title>
          <t-input label="E-mail" v-model="email" submitted email-multiple hide-label/>
          Iremos processar seu relatório dentro de aproxidamente 10 minutos. Você receberá um aviso quando estiver
          finalizado.

        </t-form-wrapped>

      </b-form>

    </validation-observer>

    <template #modal-footer="{ ok }">

      <t-button @click="ok()" text="Solicitar Relatório" :sending="onSending" primary/>

    </template>

  </b-modal>

</template>
<script>
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
  name: 't-report-generate-dialog-routine-by-part',

  data() {
    return {
      status: "",
      email: "",
    }
  },
  props: {
    command: {
      type: String,
      default: 'insert'
    },
    url: String,
    serverOnlaineApi: Boolean,
    totalRows: Number,
    totalParts: Number,
  },
  mounted() {
    this.email = ui.getEmailUser()
  },
  computed: {
    onStatus() {
      return this.status
    },
    onSending() {
      return this.status === "sending"
    },
  },
  methods: {

    onShow() {
      this.$emit('show')
    },
    onHidden() {
      this.$emit('hidden')
    },
    async handleOk(bvModalEvt) {

      bvModalEvt.preventDefault()
      await this.onSubmit()

    },
    async onSubmit() {

      //Avisa o pai que mudou o status para submetido
      this.status = "subject"

      await this.$refs.validation.validate().then(async success => {

        if (!success) {
          return;
        }

        if (this.serverOnlaineApi) {

          await http.get(this.url + "&emailRoutineByPart="+this.email).then(() => {
            this.status = "subject"
            this.$bvModal.hide('modal-report-dialog-routine-by-part')
            ui.msg(this, 'Relatório solicitado', "Seu relatório foi solicitado com sucesso!<br />Caso desejar aguardar o processamento acesse: <br /><a href='/general/my-report'>Meus Relatórios</a> ou clique no botão 'Histórico'")
            this.$emit('onSubmit')


          }).catch(() => {
            ui.msgError(this, 'Desculpe, houve uma falha ao tentar adicionar seu relatório na fila de processamento, por favor tente novamente e caso o problema persistir informe nosso suporte técnico.')
          })

        } else {

          let url = this.url.replace('general/report/generate?', 'general/report/stack-routine-by-part?totalRows=' + this.totalRows + '&totalParts=' + this.totalParts + "&emailRoutineByPart=" + this.email + "&")


          await http.get(url).then(() => {

            this.$bvModal.hide('modal-report-dialog-routine-by-part')
            ui.msg(this, 'Relatório solicitado', "Seu relatório foi solicitado com sucesso!<br />Por favor, aguarde até 10min para receber no e-mail informado.")

            this.$emit('onSubmit')

          }).catch(() => {
            ui.msgError(this, 'Desculpe, houve uma falha ao tentar adicionar seu relatório na fila de processamento, por favor tente novamente e caso o problema persistir informe nosso suporte técnico.')
          })


        }


      });


    }


  }
}
</script>
